import { type MetaFunction } from '@remix-run/node'

import { Footer, Header } from '#app/components'
import { Wrapper } from '#app/components/ui'
import { useOptionalUser } from '#app/utils/user.ts'

export default function AboutRoute() {
	const user = useOptionalUser()
	const isLoggedIn = user?.id ? true : false
	return (
		<main>
			<Header isLoggedIn={isLoggedIn} />
			<div className="flex w-full flex-col items-center">
				<Wrapper>
					<div className="bg-white px-6 py-24 dark:bg-background sm:py-32 lg:px-8">
						<div className="mx-auto max-w-2xl text-center">
							<h2 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
								About Top Timelines
							</h2>

							<p className="mt-6 py-4 leading-8 dark:text-gray-300">
								At Top Timelines, we empower event professionals by simplifying
								the complex world of event planning. Our innovative platform
								provides comprehensive tools for managing every aspect of your
								event—from team coordination and vendor relations to detailed
								timeline creation and calendar integration.
							</p>
							<p className="py-4 leading-8 ">
								Our mission is to transform the event planning process, making
								it as seamless and efficient as possible. Whether you're
								organizing a corporate conference, managing a music festival, or
								planning the wedding of the century, Top Timelines ensures that
								every detail is meticulously managed.
							</p>
							<p className="py-4 leading-8 ">
								Loved by event planners worldwide, Top Timelines is praised for
								its intuitive design and powerful features like real-time
								updates, timeline clarity, and AI-driven analytics. These tools
								not only facilitate flawless execution but also enhance
								collaboration and client management, helping you deliver
								unforgettable experiences.
							</p>
							<p className="mt-6">
								Join the thousands of event planners who have taken their
								projects to new heights with Top Timelines. Experience the
								future of event planning today and see why our users describe
								our platform as a game-changer in the industry!
							</p>
						</div>
					</div>
				</Wrapper>
			</div>
			<Footer />
		</main>
	)
}

export const meta: MetaFunction = () => [{ title: 'Top Timelines: About' }]
